import mitt from 'mitt'
import type { Emitter } from 'mitt'

type ApplicationEvents = {
  'contract:fill': void
  'contract:prepare': void
  'contract:print': void
  'coupons:refresh': void
  'form:error': string
  'influencer-posts:refresh': void
  'locale:changed': string
  'subscription:canceled': string
  'subscription:required': string
  'swap:company': void
  'table:refresh': void
  'viral-link-urls:refresh': void
}

const emitter: Emitter<ApplicationEvents> = mitt<ApplicationEvents>()

export const useEmit = emitter.emit
export const useListen = emitter.on
export const useRemoveListener = emitter.off
